<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  @import '~spinkit/spinkit.min.css';
  @import '~jqwidgets-scripts/jqwidgets/styles/jqx.base.css';

  .ui.selection.dropdown.error {
	border-color: #e55353;
  }
  .ui.selection.dropdown {
	border-color: #2eb85c;
  }
</style>